import { IB2CUser } from "./IB2CUser";
import { IUserGroup } from "./IUserGroup";

export class B2CUser implements IB2CUser {
    givenName: string;
    surName: string;
    emailAddress: string;
    objectId: string;
    customerId: string;
    groups: IUserGroup[];

    constructor(givenName: string, surName: string, emailAddress: string, objectId: string, customerId: string, groups: IUserGroup[]) {
        this.givenName = givenName;
        this.surName = surName;
        this.emailAddress = emailAddress;
        this.objectId = objectId;
        this.groups = groups;
        this.customerId = customerId;
    }


}
